export default __webpack_public_path__ + "static/media/WhatsNew.9884cf4b.png";